/**
 * Shared helpers for Resources (mirrors donor Inspiration/BlogReader logic).
 * Works with recipient article shape: { slug, title, excerpt, category, body, bodyHtml, ... }.
 */

/**
 * @param {string} [dateString]
 * @returns {string}
 */
export function formatDate(dateString) {
  if (!dateString) return "";
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  } catch {
    return String(dateString);
  }
}

/**
 * Strip HTML tags for plain-text excerpt.
 * @param {string} [html]
 * @returns {string}
 */
export function stripHtml(html) {
  if (!html) return "";
  const tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return (tmp.textContent || tmp.innerText || "").trim();
}

/**
 * Category label for display (recipient uses article.category; donor used hero kicker or categories[0]).
 * @param {{ category?: string }} article
 * @returns {string}
 */
export function getCategoryLabel(article) {
  if (!article) return "";
  const cat = article.category;
  return cat ? String(cat).toUpperCase() : "";
}
